import React, { useEffect, useState } from 'react'
import style from './HeroSection.module.css'
import { Link } from 'react-router-dom'

const HeroSection = () => {
    const [signedIn, setSignedIn] = useState(false);
    useEffect(() => {
        const tokens = localStorage.getItem("token");
        if (tokens) {
            setSignedIn(true);
        }
    }, []);
    return (
        <div id="hero" className={style.heroSection_Background} >
            <div className={style.herocontainer}>

                <div className={style.herosectionh1text}>

                    <h1 className={style.heroSection_h1}>EditLaTeX Reinvents the way you work</h1>
                </div>
                {/* <div className={style.loginContainer}>
                    <input type="text" placeholder='Enter your email' className={style.heroInput} />
                    <input type="text" placeholder='Enter your password' className={style.heroInput} />
                    <button className={style.heroButton}>Sign up for free</button>
                </div> */}
                {!signedIn && (
                    <div>
                        <Link to={"/signup"}>
                            <button className={style.heroButton}>Sign up for free</button>
                        </Link>
                    </div>
                )}

            </div>

            <div>
                <img src={process.env.PUBLIC_URL + "/NewPages/Homepage/HomeHeroImg.webp"} alt="" />
            </div>

        </div>
    )
}

export default HeroSection
